export const formatPrice = (value: number | string): string => {
    return Number(value).toFixed(2);
  };
  